import { Component, ViewChild } from '@angular/core';
import { StorageService } from '../../core/storage/storageService';
import { TransactionFacade } from '../../models/transactions/transactionFacade';
import { Merchant } from '../../models/merchant/merchant';
import { TransactionTableViewComponent } from '../../components/transaction/transaction-table-view/transaction-table-view.component';
import { AccessManager } from '../../components/ui/access-manager/access-manager';
import { UIErrorHandler } from '../../core/uiErrorHandler';
import { TableView } from '../../components/ui/filterable-table/tableView';
import { CPOPage } from '../../models/ui/cpoPage';
import { MerchantService } from '../../models/merchant/merchantService';
import { MerchantTableViewComponent } from '../../components/merchant/merchant-table-view/merchant-table-view.component';
import { AccountService } from '../../models/account/accountService';
import { Account } from '../../models/account/account';
import { Options } from '../../components/ui/filterable-table/options';

@Component({
  selector: 'app-business-hub-page',
  templateUrl: './business-hub-page.component.html',
  standalone: false,
})
export class BusinessHubPageComponent extends CPOPage {
  @ViewChild('transactionsTable') transactionTableControl:
    | TransactionTableViewComponent
    | undefined;
  @ViewChild('merchantTable') merchantTableControl:
    | MerchantTableViewComponent
    | undefined;

  selectedMerchant: Merchant | undefined; // = {};

  merchantTableOptions: Options = new Options({
    selectAction: 'expand',
  });

  isEditable: boolean = false;
  doOnboard: boolean = false;
  allowAddLocation: boolean = false;

  merchant: Merchant | undefined;
  merchantTableView: any;
  hideTable: boolean = false;

  allowMyMIDs: boolean = true;
  allowMyTransactions: boolean = true;
  allowGlobalSearch: boolean = false;

  transactionTableView: any;
  transactionsTableView: any;
  transactionsTableOptions: any = {
    paginated: false,
    filterable: false,
  };

  //locationSubscription: Observable<any>;

  //selectedTransaction: Partial<TransactionFacade> | undefined;

  constructor(
    public storage: StorageService,
    private accessManager: AccessManager,
    private uiErrorHandler: UIErrorHandler,
    public merchantService: MerchantService,
    public accountService: AccountService,
  ) {
    super(storage, uiErrorHandler, { requireLogin: true });

    this.transactionsTableView = new TableView(TransactionTableViewComponent);
    this.merchantTableView = new TableView(MerchantTableViewComponent);

    storage.removeSelectedTransaction();
    storage.removeSelectedCustomer();
    storage.removeSelectedUser();

    this.selectedMerchant = storage.getSelectedLocation() as Merchant;
  }

  override ngOnInit() {
    super.ngOnInit();

    let myAccount = this.storage.getMyAccount();

    if (myAccount) {
      if (!myAccount.locations || myAccount.locations!.length <= 1) {
        this.hideTable = true;
      }
    }

    if (this.storage.getSelectedLocation()) {
      this.hideTable = true;
    }
  }

  setupLocationTableOptions(myAccount: Account) {
    if (myAccount) {
      this.merchantTableOptions.accountId = myAccount.id;
    } else {
      if (this.storage.getNumberOfMyBusinesses() <= 1) {
        this.merchantTableOptions.filterable = false;
      }
    }
    this.merchantTableOptions.accountId = myAccount.id;
    this.merchantTableOptions.debug = 'merchant account';

    let usr = this.storage.getCurrentUser();

    if (
      usr.originalRole != 'portal.admin' &&
      usr.originalRole != 'portal.manager'
    ) {
      this.merchantTableOptions.restrictToMyMerchants = true;
    }

    this.merchantTableControl?.setOptions(this.merchantTableOptions);
    //this.merchantTableControl?.setOptions(this.merchantTableOptions);
  }

  ngAfterViewInit() {
    let usr = this.storage.getCurrentUser();

    let myAccount = this.storage.getMyAccount();

    if (this.storage.getSelectedLocation()) {
      if (!myAccount) {
        let bisId = this.storage.getSelectedLocation()?.accountId;
        if (bisId) {
          this.accountService.getAccount(bisId).then((account) => {
            this.setupLocationTableOptions(account);
          });
        } else {
          // this won't ever happen since every location is associated with a business
        }
      } else {
        this.setupLocationTableOptions(myAccount);
      }
    }

    //if (!usr) {
    //  throw "no current user";
    //}

    this.accessManager
      .getUserAccess([
        AccessManager.AUTH_GLOBAL_SEARCH,
        AccessManager.AUTH_DASHBOARD_MYTRANSACTIONS,
      ])
      .then((access) => {
        this.allowGlobalSearch = access[AccessManager.AUTH_GLOBAL_SEARCH];
        this.allowMyTransactions =
          access[AccessManager.AUTH_DASHBOARD_MYTRANSACTIONS];

        if (this.allowMyTransactions) {
          this.transactionsTableOptions.userId = usr?.id;
          this.transactionsTableOptions.merchantId =
            this.storage.getSelectedLocation()?.id;
          this.transactionTableView = new TableView(
            TransactionTableViewComponent,
          );
          this.transactionTableControl?.setOptions(
            this.transactionsTableOptions,
          );
        }
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  ngOnDestroy() {}

  public handleTransactionSelected(transaction: TransactionFacade) {
    //this.selectedTransaction = transaction;
    this.storage.setSelectedTransaction(transaction);
  }

  btnCloseTransaction_click() {
    //this.transaction = undefined;
    this.storage.removeSelectedTransaction();
  }

  btnExpandTable_click(e: Event) {
    this.hideTable = !this.hideTable;
    const currentBtn = document.querySelector('.collapsible');
    currentBtn?.classList.toggle('active');
  }
}
